export const ROUTES = {
  // Public auth
  SIGN_IN: "/",
  SIGN_UP: "/sign-up",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",
  REQUEST_INVITATION: "/request-invitation",

  // Public device
  REGISTER_DEVICE_LANDING: "/register-device/:deviceCode",
  CHECK_SMS: "/check-sms",
  CONTACT_BLOOMLIFE: "/contact-bloomlife",

  // Protected
  ONBOARDING: "/onboarding",
  ADD_DEVICE: "/add-device/:deviceCode",
  BLOOD_GLUCOSE_DEVICE_SETUP: "/blood-glucose-device-setup",
  DASHBOARD: "/dashboard",
  MEASUREMENT: {
    FASTING: "/measurement/fasting",
    MEAL: "/measurement/meal",
    QUICK_CHECK: "/measurement/quick-check",
    EDIT: "/measurement/edit/:measurementId",
  },
  QUICK_CHECK_EDIT: "/quick-check/edit/:measurementId",
  ADD_FOOD_LOG: "/add-food-log",
  FOOD_LOG_EDIT: "/food-log/edit/:formId",
  SETTINGS: "/settings",
  LINK_DEVICE: "/link-device",
  UPDATE_PROFILE: "/update-profile",
  UPDATE_MEDICATIONS: "/update-medications",
  UPDATE_REMINDERS: "/update-reminders",
  INSTRUCTION_VIDEOS: "/instruction-videos",
  DEVICE_SETUP_COMPLETED: "/device-setup-completed",
  DEVICE_LINKING_ERROR: "/device-linking-error",
} as const

/**
 * Build a path by replacing dynamic segments with actual values
 * @example buildPath(ROUTES.REGISTER_DEVICE_LANDING, { deviceCode: "ABC123" })
 */
export const buildPath = (
  pattern: string,
  params: Record<string, string>
): string => {
  let path = pattern
  Object.entries(params).forEach(([key, value]) => {
    path = path.replace(`:${key}`, value)
  })
  return path
}

/**
 * Build a query string and append it to a path
 * @example withQuery(ROUTES.SIGN_IN, { redirect: "/dashboard" })
 */
export const withQuery = (path: string, params: Record<string, string>) => {
  const query = new URLSearchParams(params).toString()
  return query ? `${path}?${query}` : path
}
